// @ts-strict-ignore
import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonItem, IonLabel, IonList } from '@ionic/react'
import { getDirMode } from 'mobile_web/modules/platform'
import { getOriginalLanguageName } from 'mobile_web/modules/settings/functions'
import strings from 'mobile_web/strings'
import { LanguageCode } from 'mytours-read-api-typescript'
import { convertLanguages, Language } from 'mytours-read-common'
import React from 'react'
import Button from '../Button'
import Modal from '../modal'
import './styles.less'
import { EventActionsEnum, sendEvent } from 'mobile_web/modules/logging/analytics'

interface Props {
	selectLanguage: (language: Language) => void
	supportedLanguages: LanguageCode[]
	selectedLanguage?: Language
	backdropDismiss?: boolean
	closeModal?: () => void
	showBackdrop?: boolean
	isOpen: boolean
	onDidDismiss?: (event: Event) => void
}

const LanguageModal: React.FC<Props> = ({
	backdropDismiss = true,
	showBackdrop = true,
	supportedLanguages,
	selectedLanguage,
	selectLanguage,
	closeModal,
	isOpen,
	onDidDismiss,
}): JSX.Element => {
	const languages = convertLanguages(supportedLanguages).sort((a, b) => a.name.localeCompare(b.name))

	const ItemContent = ({ languageCode, languageName }) => (
		<>
			<IonLabel>{languageName}</IonLabel>
			<p lang={languageCode}>{getOriginalLanguageName(languageCode)}</p>
		</>
	)

	return (
		<Modal
			data-cy="language-modal"
			isOpen={isOpen}
			showBackdrop={showBackdrop}
			backdropDismiss={backdropDismiss}
			cssClass="language-select-modal"
			onDidDismiss={onDidDismiss}
		>
			<IonCard dir={getDirMode()}>
				<IonCardHeader>
					<IonCardTitle id="dialogTitle">{strings.select_language}</IonCardTitle>
					{closeModal && (
						<Button className="close" onClick={closeModal} ariaLabel={strings.cancel}>
							<i className="fal fa-xmark" />
						</Button>
					)}
				</IonCardHeader>
				<IonCardContent>
					<IonList aria-labelledby="dialogTitle">
						{selectedLanguage && (
							<IonItem role="button" className="active" aria-selected={true} arial-label={selectedLanguage.name || ''}>
								<i className="icon far fa-check" />
								<ItemContent languageCode={selectedLanguage.code} languageName={selectedLanguage.name} />
							</IonItem>
						)}
						{languages.map(
							(row, index) =>
								selectedLanguage?.code !== row.code && (
									<IonItem
										data-cy={`language-${row.code}`}
										arial-label={row.name || ''}
										role="button"
										key={index}
										onClick={() => {
											sendEvent(EventActionsEnum.ChangeLanguage, {
												language: row.code,
											})
											selectLanguage(row)
										}}
									>
										<ItemContent languageCode={row.code} languageName={row.name} />
									</IonItem>
								),
						)}
					</IonList>
				</IonCardContent>
			</IonCard>
		</Modal>
	)
}

export default LanguageModal
